<template>
  <div class="emoji-picker-wrapper">
    <div @click.stop="toggleVisible">
      <div
        :class="{
          expression: true,
          expression2: visible,
        }"
      >
        <svg-btn
          class="expressionIcon"
          icon-class="icon-gfans-expression"
        ></svg-btn>
      </div>
    </div>
    <!-- <transition name="fade-scale"> -->
      <div v-show="visible" class="emoji-picker-box" @click.stop>
        <div class="emojiBox">
          <!-- 头部分类 -->
          <div class="emojiHead">
            <div
              :class="{
                headBox: true,
                active: status == item.type,
              }"
              @click="checkStatus(item)"
              v-for="item in data.tag_type"
              :key="item.type"
            >
              <img class="headImg" :src="item.url" />
            </div>
          </div>
          <!-- 表情主体 -->
          <div class="emojiContent">
            <div
              class="emoji"
              v-for="(item, index) in data.list"
              :key="index"
              @click="handleEmojiSelect(item)"
            >
              <img class="imgE" :src="item.url" />
            </div>
          </div>
        </div>
      </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus'
// 闭包实现的ID生成器
const generateId = (() => {
  let id = 0
  return () => `emoji-picker-${Date.now()}-${id++}`
})()
export default {
  props: {
    status: {
      type: [Number, String],
      default: 1,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      visible: false,
      type: 1,
      instanceId: generateId()
    }
  },

  mounted() {
    // 创建独立的事件处理器
    this.globalCloseHandler = (excludeId) => {
      if (this.instanceId !== excludeId) this.close()
    }
    
    // 监听全局关闭事件
    this.$root.$on('closeAllPopups', this.globalCloseHandler)
    // 点击外部关闭
    document.addEventListener('click', this.close)
  },

  beforeDestroy() {
    document.removeEventListener('click', this.close)
    // 精准移除事件监听器
    this.$root.$off('closeAllPopups', this.globalCloseHandler)
  },
  methods: {
    toggleVisible() {
      if (this.$store.state.isLogin === 0) {
        eventBus.$emit('showLogin', {})
        return
      }

      // 触发全局关闭事件（包括ClickPop组件）
      this.$root.$emit('closeAllPopups', this.instanceId)
      this.visible = !this.visible
    },
    //切换分类
    checkStatus: _.debounce(
      function (row) {
        if (this.status == row.type) return
        this.$emit('check', row.type)
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //选择表情
    handleEmojiSelect(row) {
      this.$emit('select', row.url)
    },
    close() {
      if (this.visible) {
        this.visible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.emoji-picker-wrapper {
  position: relative;
  display: inline-block;
  user-select: none;
  .expression {
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    @include useTheme {
      color: getVar('text-color8-52565a');
    }
    &:hover {
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .expressionIcon {
      width: 22px;
      height: 22px;
    }
  }
  .expression2 {
    @include useTheme {
      color: getVar('primary-color') !important;
    }
  }
  .emoji-picker-box {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 99;
    // 添加硬件加速
    transform: translateZ(0);
    .emojiBox {
      width: 508px !important;
      box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.08),
        0px 12px 24px 2px rgba(0, 0, 0, 0.04),
        0px 0px 10px -5px rgba(0, 0, 0, 0.16);
      border-radius: 12px;
      .emojiHead {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 12px 12px 0 0;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
          background: getVar('bg-color1-f4f6f8');
        }
        .headBox {
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          border-radius: 8px;
          cursor: pointer;
          &:hover {
            @include useTheme {
              background: getVar('bg-color5-e8e8e8');
            }
          }
          .headImg {
            width: 23px;
            height: 23px;
          }
        }
      }
      .active {
        @include useTheme {
          background: getVar('bg-color-content');
        }
      }
      .emojiContent {
        display: flex;
        flex-wrap: wrap;
        padding: 16px;
        height: 288px;
        // overscroll-behavior: contain; /* 现代浏览器支持 */
        // -webkit-overflow-scrolling: touch; /* iOS 平滑滚动 */
        overflow-y: auto;
        border-radius: 0 0 12px 12px;
        @include useTheme {
          background: getVar('bg-color15-ffffff');
        }
        .emoji {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 8px;
          cursor: pointer;
          margin-right: 19px;
          margin-bottom: 20px;
          &:hover {
            @include useTheme {
              background: getVar('bg-color5-e8e8e8');
            }
          }
          &:nth-child(9n) {
            margin-right: 0 !important;
          }
          &:nth-child(9n + 1):nth-last-child(-n + 9),
          &:nth-child(9n + 1):nth-last-child(-n + 9) ~ .emoji {
            margin-bottom: 0;
          }
          .imgE {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
  .active {
    @include useTheme {
      color: getVar('primary-color') !important;
    }
  }
  .fade-scale-enter-active,
  .fade-scale-leave-active {
    transition: all 0.3s ease;
    transform-origin: left top;
  }

  .fade-scale-enter,
  .fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>
